import React, { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import Modal from "../../molecules/Modal";
import TableDocuments from "../../organisms/clientes/empresas/documentos/TableDocuments";
import ModalUploadDocument from "../../organisms/clientes/empresas/documentos/ModalUploadDocument";
import useModal from "../../../hooks/useModal";
import { 
    GET_ANNUAL_STATEMENT_DOCUMENTS, 
    GET_COMPILANCE_OPINIONS_DOCUMENTS, 
    GET_ENTERPRISE_BY_ID, 
    GET_FILE_TYPES, 
    GET_FINANCIAL_REPORTING, 
    GET_LEGAL_ENTITIE_DOCUMENTS, 
    GET_MAILBOX, 
    GET_NATURAL_PERSON_DOCUMENTS, 
    GET_PROVISIONAL_PAYMENTS_DOCUMENTS 
} from "../../../api/apiEmpresas";
import DocumentsTemplateHeader from "../../organisms/clientes/empresas/headers/DocumentsTemplateHeader";
import { useSession } from "../../../context/SessionContext";

const DocumentsTemplate = ({ id, tipo, tabla }) => {
    const { user } = useSession();
    const [types, setTypes] = useState();
    const [empresa, setEmpresa] = useState();
    const [loading, setLoading] = useState(false);
    const [documentos, setDocumentos] = useState();
    const { open, close, isOpen } = useModal();

    const fetchDocumentos = useCallback (async (tabla, tipo, id) => {
        const fetchFunctions = {
            archivo_permanente: {
                LegalEntitie: GET_LEGAL_ENTITIE_DOCUMENTS,
                NaturalPerson: GET_NATURAL_PERSON_DOCUMENTS,
            },
            opiniones_cumplimiento: GET_COMPILANCE_OPINIONS_DOCUMENTS,
            declaracion_anual: GET_ANNUAL_STATEMENT_DOCUMENTS,
            pagos_provicionales: GET_PROVISIONAL_PAYMENTS_DOCUMENTS,
            reportes_financieros: GET_FINANCIAL_REPORTING,
            buzones: GET_MAILBOX,
        };

        const fn = typeof fetchFunctions[tabla] === "function"
          ? fetchFunctions[tabla]
          : fetchFunctions[tabla]?.[tipo];

        if (fn) {
          try {
            const response = await fn(id);
            setDocumentos(response);
          } catch (error) {
            console.error(error);
          }
        }
      }, []);

    const getDocuments = useCallback(async () => {
        try {
            setLoading(true);
            const fileData = await GET_FILE_TYPES();
            setTypes(fileData);
            const enterpriseData = await GET_ENTERPRISE_BY_ID(id);
            setEmpresa(enterpriseData);
            await fetchDocumentos(tabla, enterpriseData.type, enterpriseData.id);

        } catch (error) {
            console.error(error);
            toast.error("Error al cargar los documentos");
        } finally {
            setLoading(false);
        } 
    }, [id, tabla, fetchDocumentos]);

    useEffect(() => {
        getDocuments();
    }, [getDocuments]);

    return(
        <div className="w-full h-full flex flex-col space-y-2">
            <DocumentsTemplateHeader
                empresa={empresa} user={user}
                tabla={tabla} tipo={tipo} open={open}
            />
            {user?.role === "Client" && user?.roleInfo?.isAllowed === false ?
                    <div className="text-center">
                        <p>Contacta con tu asesor</p>
                    </div>
                :
                    <TableDocuments
                        data={(documentos && documentos[tipo]) ? documentos[tipo] : ""}
                        tabla={tabla}
                        loading={loading}
                        empresa={empresa}
                        refetch={getDocuments}
                        documentos={documentos}
                        types={types}
                    />
            }
            {isOpen && empresa &&
                <Modal onClose={close} title="Subir documento">
                    <ModalUploadDocument
                        tipo={tipo}
                        empresa={empresa}
                        documentos={documentos}
                        tabla={tabla}
                        onClose={close}
                        refetch={getDocuments}
                        types={types}
                    />
                </Modal>
            }
        </div>
    )
};

export default DocumentsTemplate;